<script>
import axios from "axios";
import FormPago from "../../formulario/FormPago.vue";
import FormPagoEditar from "../../formulario/FormPagoEditar.vue";
import moment from "moment";

import { getVariant } from "../../../helpers/badgeLookupTable";

import ModalFormEditStatusVistoBueno from "../../modals/ModalFormEditStatusVistoBueno.vue";

export default {
  components: { FormPago, FormPagoEditar, ModalFormEditStatusVistoBueno },
  props: {
    despacho: Object,
  },
  data() {
    return {
      fields: [
        { key: "numero_documento", label: "N° de documento" },
        { key: "institucion", label: "Institucion" },
        { key: "numero_solicitud", label: "N° Solicitud" },
        { key: "fecha_recepcion", label: "F. de ingreso" },
        { key: "fecha_aprobacion", label: "Fecha de aprobación" },
        { key: "estado", label: "Estado" },
        { key: "acciones", label: "Acciones" },
      ],
      pageMeta: { current_page: 1 },

      vistosBuenos: [{}],
      vistosBuenosIsPending: null,

      selected: { id: undefined, base: { estado: undefined } },
      statusModal: false,
    };
  },

  methods: {
    getVariant(estado) {
      return getVariant(estado);
    },
    async fetch() {
      const query = {
        params: {
          page: this.pageMeta.current_page || 1,
        },
      };

      try {
        const { data, status } = await axios.get(
          `/api/admin/despachos/${this.despacho.id}/vistos-buenos`,
          query
        );

        if (status == 200 && data?.data && data?.meta) {
          this.vistosBuenos = data.data;
          this.pageMeta = data.meta;
        }
      } catch (e) {
        console.error("Error fetching vistos buenos: ", e);
      }
    },
    async updateStatus() {
      const query = {
        estado: this.selected.status,
      };

      try {
        const { status } = await axios.post(
          `/api/admin/documentos/${this.selected.documentId}/validar-vb`,
          query
        );

        if (status == "200") {
          await this.fetch();
        }

        this.statusModal = false;
      } catch (e) {
        console.error("There was a problem updating a document status:", e);
      }
    },
  },
  watch: {
    "pageMeta.current_page": function () {
      this.fetch();
    },
  },
  mounted() {
    this.fetch(this.despacho.id);
  },
};
</script>

<template>
  <div class="flex flex-col gap-4 p-[2%]">
    <b-table
      striped
      hover
      show-empty
      responsive
      :items="vistosBuenos"
      :fields="fields"
    >
      <template #empty>
        <h4>No hay elementos en la lista</h4>
      </template>

      <template #cell(numero_documento)="row">
        <div class="flex flex-row gap-2 items-center">
          <div class="h-6 w-[5px]" :class="[getVariant(row.item.estado)]"></div>
          {{ row.item?.numero_documento ?? "-" }}
        </div>
      </template>

      <template #cell(institucion)="row">
        {{ row.item?.institucion ?? "-" }}
      </template>

      <template #cell(numero_solicitud)="row">
        {{ row.item?.numero_solicitud ?? "-" }}
      </template>

      <template #cell(fecha_recepcion)="row">
        <div class="text-nowrap">
          {{ moment(row.item?.fecha_recepcion).format("DD-MM-YYYY") ?? "-" }}
        </div>
      </template>
      <template #cell(fecha_aprobacion)="row">
        <div class="text-nowrap">
          {{
            row.item?.fecha_aprobacion
              ? moment(row.item.fecha_aprobacion).format("DD-MM-YYYY")
              : "-"
          }}
        </div>
      </template>
      <template #cell(fecha_eta)="row">
        <div class="text-nowrap">
          {{ moment(row.item.fecha_eta).format("DD-MM-YYYY") ?? "-" }}
        </div>
      </template>
      <template #cell(documento_cde_id)="row">
        <div class="text-nowrap">
          {{ row.item.documento_cde_id ?? "-" }}
        </div>
      </template>
      <template #cell(estado)="row">
        <div
          @click="
            () => {
              selected.id = row.item.id;
              selected.base.estado = row.item.estado;
              statusModal = true;
            }
          "
          class="text-nowrap hover:brightness-110 transition-all cursor-pointer text-center my-auto text-white px-2 hover:scale-105"
          :class="[getVariant(row.item.estado)]"
          v-if="!!row.item.estado"
        >
          {{ row.item.estado ?? "-" }}
        </div>
      </template>
      <template #cell(acciones)="row">
        <div class="flex flex-col items-center gap-4 justify-center px-2">
          <div class="flex flex-row items-center gap-2">
            <button
              class="btn-extra-primario"
              @click="
                () =>
                  $router.push({
                    name: 'Documento',
                    params: {
                      despachoId: row.item.despacho?.id,
                      documentoId: row.item.id,
                    },
                  })
              "
            >
              <fas :icon="['fas', 'eye']"></fas>
              Ver documento
            </button>
          </div>
        </div>
      </template>
    </b-table>

    <ModalFormEditStatusVistoBueno
      :visible="statusModal"
      :documento="selected"
      @close-modal="() => (statusModal = false)"
      @refetch="() => fetch(despacho.id)"
    />
  </div>
</template>
